import { showAlertDialog } from '@juvare/common-web-ui/DialogHelper';
import Attachment from '@mui/icons-material/Attachment';
import { IconButton, Typography } from '@mui/material';
import React from 'react';
import { useAlertUiTranslation } from '../../../../../hooks';
function totalAttachmentsSize(files, selectedFiles) {
    let totalSize = 0;
    files.forEach((f) => {
        if (f.fileSize) {
            totalSize += f.fileSize;
        }
    });
    selectedFiles.forEach((f) => (totalSize += f.size));
    return totalSize;
}
const AddAttachmentButton = ({ attachments, onSaveAttachments, loadingAttachmentUpload, inputFileRef, }) => {
    const { t } = useAlertUiTranslation();
    function validate(files, fileList) {
        if (fileList.length + files.length > 10) {
            throw Error(t('pages.edit.errors.ALERT_FILES_MAX_LENGTH'));
        }
        const selectedFiles = [];
        for (let i = 0; i < fileList.length; i++) {
            selectedFiles.push(fileList[i]);
        }
        if (totalAttachmentsSize(files, selectedFiles) > 10485760) {
            throw Error(t('pages.edit.errors.ALERT_FILE_SIZE_MAX_LENGTH'));
        }
        return selectedFiles;
    }
    const changeHandler = (event) => {
        event.preventDefault();
        if (event.target.files) {
            if (window.File && window.FileReader && window.FileList && window.Blob) {
                try {
                    const validFiles = validate(attachments, event.target.files);
                    if (validFiles.length > 0) {
                        onSaveAttachments(validFiles);
                    }
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                }
                catch (e) {
                    showAlertDialog({
                        title: t('pages.edit.validationFailed'),
                        content: React.createElement(Typography, null, e.message),
                    });
                }
            }
            else {
                alert(t('pages.edit.richTextEditors.apiNotSupportedByBrowser'));
            }
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("input", { id: 'icon-button-file', "data-test": 'icon-button-file', "data-testid": 'file-uploader', type: 'file', hidden: true, onChange: changeHandler, onClick: (event) => (event.target.value = ''), multiple: true, disabled: loadingAttachmentUpload, ref: inputFileRef }),
        !inputFileRef && (React.createElement("label", { htmlFor: 'icon-button-file' },
            React.createElement(IconButton, { "data-testid": 'add-attachment-btn', component: 'span', size: 'small', color: 'inherit', disabled: loadingAttachmentUpload, "aria-label": t('pages.edit.richTextEditors.attachment') },
                React.createElement(Attachment, null))))));
};
export default AddAttachmentButton;
